import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ViewModelProperty } from '../../models';
import { VmpFieldType, VmpSelectionType } from '../../enums';
import { MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';

import { VMPFormGroupItemComponent } from '../vmp-form-group-item/vmp-form-group-item.component';
import { ButtonEditComponent } from '../../editors/button-edit/button-edit.component';
import { SelectEditComponent } from '../../editors/select-edit/select-edit.component';
import { LookupEditComponent } from '../../editors/lookup-edit/lookup-edit.component';
import { CheckEditComponent } from '../../editors/check-edit/check-edit.component';
import { TranslatePipe } from '@ngx-translate/core';
import { StaticTextComponent } from '../../editors/static-text/static-text.component';

@Component({
  selector: 'ldw-vmp-form-group',
  templateUrl: './vmp-form-group.component.html',
  styleUrls: ['./vmp-form-group.component.css'],
  imports: [
    MatExpansionPanel,
    MatExpansionPanelHeader,
    ReactiveFormsModule,
    VMPFormGroupItemComponent,
    ButtonEditComponent,
    SelectEditComponent,
    LookupEditComponent,
    CheckEditComponent,
    TranslatePipe,
    StaticTextComponent
  ]
})
export class VMPFormGroupComponent implements OnInit {
  static groupid = 0;

  private isInitialized = false;
  private _vmpList: ViewModelProperty[] | undefined = undefined;
  private vmpGroupCaptionText = '';
  fldType = VmpFieldType;
  @Input() captionWidth = 100;
  @Input() captionVisible = true;
  @Input() valueWidth = 400;
  @Input() expanded = false;
  @Input() groupCaptionText = '';
  @Input() groupCaptionVisible = true;

  @Input() form!: UntypedFormGroup;

  @Output() actionClicked = new EventEmitter<ViewModelProperty>();

  ngOnInit(): void {
    this.isInitialized = true;
    this.buildFormGroup();
  }

  @Input()
  get vmpList(): ViewModelProperty[] | undefined {
    return this._vmpList;
  }

  set vmpList(value: ViewModelProperty[] | undefined) {
    if (this._vmpList == value) {
      return;
    }
    this._vmpList = value;
    if (this.isInitialized) {
      this.buildFormGroup();
    }
  }

  get captionText(): string {
    if (!this.groupCaptionVisible) {
      return '';
    }
    if (this.groupCaptionText != '') {
      return this.groupCaptionText;
    }
    return this.vmpGroupCaptionText;
  }

  isSelect(vmp: ViewModelProperty): boolean {
    if (vmp == null) {
      return false;
    }
    return vmp.selectionType == VmpSelectionType.Select;
  }

  isStaticText(vmp: ViewModelProperty): boolean {
    if (vmp == null) {
      return false;
    }
    return vmp.fieldType == VmpFieldType.StaticText;
  }

  isButtonEdit(vmp: ViewModelProperty): boolean {
    if (vmp == null) {
      return false;
    }
    return vmp.selectionType == VmpSelectionType.ButtonEdit;
  }

  buildFormGroup(): void {
    if (this.form == null) {
      this.form = new UntypedFormGroup({});
    }

    if (this.vmpList == undefined) {
      return;
    }
    const group: any = {};
    this.vmpList.forEach((vmp) => {
      group[vmp.fieldName] = new UntypedFormControl([], vmp.required ? Validators.required : undefined);
    });
    this.getVMPGroupCaptionName();
    this.form.addControl(this.getGroupName(), new UntypedFormGroup(group));
  }

  private getGroupName(): string {
    if (this.vmpGroupCaptionText != '') {
      return this.vmpGroupCaptionText;
    }
    const name = 'GROUP' + VMPFormGroupComponent.groupid;
    VMPFormGroupComponent.groupid = VMPFormGroupComponent.groupid + 1;
    return name;
  }

  private getVMPGroupCaptionName() {
    this.vmpGroupCaptionText = '';
    if (this.vmpList == undefined) {
      return;
    }
    this.vmpList.forEach((vmp) => {
      if (this.vmpGroupCaptionText == '') {
        if (vmp.subGroupName !== undefined) {
          this.vmpGroupCaptionText = vmp.subGroupName;
        }
      }
    });
  }
}
